import dynamic from "next/dynamic";

export const OfficesMap = dynamic(() => import("./component"));
